/**
 * @file Timeline 时间线
 * @description 垂直事件流。
 *
 * @whenToUse 操作日志、审批记录、变更历史。
 * @whenNotToUse 步骤引导（用 Steps）。
 */

import type { ReactNode } from 'react'
import { cn } from '@/lib/cn.ts'

export type TimelineItem = {
  key: string
  title: ReactNode
  description?: ReactNode
  time?: ReactNode
  /** 自定义节点色点 class（默认 primary） */
  colorClassName?: string
}

export type TimelineProps = {
  items: TimelineItem[]
  className?: string
}

export function Timeline({ items, className }: TimelineProps) {
  return (
    <ul className={cn('flex flex-col', className)}>
      {items.map((item, index) => {
        const last = index === items.length - 1
        return (
          <li key={item.key} className="relative flex gap-3 pb-6 last:pb-0">
            {!last ? (
              <span
                className="absolute top-3 bottom-0 left-[5px] w-px bg-border"
                aria-hidden
              />
            ) : null}
            <span
              className={cn(
                'relative z-10 mt-1.5 size-2.5 shrink-0 rounded-full border-2 border-primary bg-raised',
                item.colorClassName,
              )}
              aria-hidden
            />
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <div className="text-sm font-medium text-foreground">
                  {item.title}
                </div>
                {item.time ? (
                  <div className="text-xs text-muted">{item.time}</div>
                ) : null}
              </div>
              {item.description ? (
                <p className="mt-1 text-xs text-muted">{item.description}</p>
              ) : null}
            </div>
          </li>
        )
      })}
    </ul>
  )
}
